import { render, staticRenderFns } from "./registroPropio.vue?vue&type=template&id=0547009a&scoped=true"
import script from "./registroPropio.vue?vue&type=script&lang=js"
export * from "./registroPropio.vue?vue&type=script&lang=js"
import style0 from "./registroPropio.vue?vue&type=style&index=0&id=0547009a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547009a",
  null
  
)

export default component.exports